import React, { useState, useEffect } from 'react';

import {
  RootState,
  bankAccountDetailRequest,
  fetchRCIAccountRequest,
  fetchRCIAccountStatusRequest,
  fetchRewardAccountRequest,
} from '@rb-serve-app/core';
import { useSelector, useDispatch } from 'react-redux';
import CommanModal from '../../components/CommanModal';

interface UnlinkRogersBenefitsProps {
  isUnlinkAccountPopup: boolean;
  setUnlinkAccountPopup: (value: boolean) => void;
  setShowConfirmModal: (value: boolean) => void;
  setShowSuccessModal: (value: boolean) => void;
  setNextLinkageDate: (value: any) => void;
  nextLinkageDate: any;
  setLinkageStatusText: (value: any) => void;
  setIsUnlinkError: (value: boolean) => void;
}

const UnlinkRogersBenefits: React.FC<UnlinkRogersBenefitsProps> = ({
  isUnlinkAccountPopup,
  setUnlinkAccountPopup,
  setShowConfirmModal,
  setShowSuccessModal,
  setNextLinkageDate,
  nextLinkageDate,
  setLinkageStatusText,
  setIsUnlinkError,
}) => {
  const dispatch = useDispatch();

  const [isUnlinking, setIsUnlinking] = useState(false);
  const [canUnlink, setCanUnlink] = useState(false);

  const [isOpen, setIsopen] = useState(isUnlinkAccountPopup);

  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );

  const { accountId, customerId } = useSelector(
    (state: RootState) => state.user
  );

  const {
    nextLinkAttemptDate,
    rciAccountDetails,
    rciAccountStatus,
    linkingStatus,
    loading,
    status,
    detail,
    error,
  } = useSelector((state: RootState) => state.banLinkage);

  const { entries, assets } = contentfulData;
  const { rb_roam_like_home, rb_links } = entries;
  const content = rb_roam_like_home?.rbUnlinkRogersBenefits;
  const eligibleContent = rb_roam_like_home?.rbRoamLikeHomeEligible;

  useEffect(() => {
    dispatch(
      fetchRCIAccountStatusRequest({
        accountId: accountId,
      })
    );

    dispatch(
      fetchRCIAccountRequest({
        accountId: accountId,
      })
    );
  }, []);

  useEffect(() => {
    if (rciAccountDetails?.bankAccountResponse) {
      const linkageStatus = rciAccountDetails.bankAccountResponse.linkageStatus;
      const linkageDate = rciAccountDetails.bankAccountResponse.linkageDate;
      // Update status text based on linkage status
      if (linkageStatus === '1') {
        setLinkageStatusText(content?.unlinkSubTitle || 'Your card is linked.');
        setCanUnlink(true);
      } else if (linkageStatus === '4') {
        setLinkageStatusText(
          content?.linkedSubTitle || 'Your card is unlinked.'
        );
        setCanUnlink(false);
      } else {
        setLinkageStatusText(
          rciAccountStatus?.linkStatus
            ? content?.unlinkSubTitle || 'Your card is linked.'
            : content?.linkedSubTitle || 'Your card is unlinked.'
        );
        setCanUnlink(!!rciAccountStatus?.linkStatus);
      }

      // Calculate next linkage date as today + 35 days
      const today = new Date();
      const nextDate = new Date(today);
      nextDate.setDate(nextDate.getDate() + 35);

      const formattedDate = nextDate.toISOString().split('T')[0];
      setNextLinkageDate(formattedDate);
      console.log('todayDate', today);
      console.log('NextLinkageDate', formattedDate);
    }
  }, [rciAccountDetails, rciAccountStatus]);

  useEffect(() => {
    if (isUnlinking && !loading) {
      setIsUnlinking(false);
      console.log('Reaching here ---', error);
      if (
        linkingStatus === true ||
        status === 'Success' ||
        detail?.includes(content?.successfullyUnlinked)
      ) {
        setCanUnlink(false);
        setLinkageStatusText(
          content?.linkedSubTitle || 'Your card is unlinked.'
        );
        setShowSuccessModal(true);
        dispatch(bankAccountDetailRequest({ accId: accountId }));
        dispatch(
          fetchRewardAccountRequest({ user_id: accountId.replace(/^0+/, '') })
        );
      }
      //   else if (
      //     error?.status !== 'Success' ||
      //     error?.detail?.includes('Error')
      //   )
      else if (error) {
        setIsUnlinkError(true);
      }
    }
  }, [isUnlinking, loading, linkingStatus, status, detail]);

  const handleUnlinkAccount = () => {
    setUnlinkAccountPopup(false);
    setShowConfirmModal(true);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setUnlinkAccountPopup(false);
  };

  const importantItems = [
    {
      id: '1',
      text: `${content?.headerText} ${rciAccountDetails?.bankAccountResponse?.ban || ''} ${content?.headerText1}`,
    },
    {
      id: '2',
      text: `${content?.requestToRelink + ' '}`,
    },
  ];
  const handleTermsPress = () => {
    const googleDocsUrl = `https://docs.google.com/gview?url=${rb_links?.rbLinksCollection?.more_digital_terms_and_conditions_pdf}&embedded=true`;
    window.open(googleDocsUrl, '_blank');
  };

  return (
    <CommanModal
      isOpen={isOpen}
      onClose={handleCancel}
      onExtraButtonClick={handleUnlinkAccount}
      buttonClassName={'flex-row'}
      // onClose={handleUnlinkAccount}
      // onExtraButtonClick={handleCancel}
      cardStatus={true}
      width="xl:w-[450px] lg:w-[450px] md:w-[450px] w-[100%]"
      jsxContent={
        <div className="w-40%">
          <div
            className="mb-4 text-[#1F1F1F] text-[18px] text-center font-medium"
            aria-label={content?.unlinkTitle}
          >
            {content?.unlinkTitle || 'Unlink Rogers account'}
          </div>
          <div className="bg-[#F1FDFF] p-7 my-6">
            <h2
              className="text-black text-[15px] font-[350] mb-3"
              aria-label={content?.important}
            >
              {content?.important || 'Important'}
            </h2>
            <ul className="list-decimal list-inside space-y-3 text-black text-[15px] font-[350]">
              {importantItems.map((item) => (
                <li key={item.id}>
                  {item.text}
                  {item.id === '2' && (
                    <strong>
                      {nextLinkageDate || nextLinkAttemptDate || ''}.
                    </strong>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="text-[13px] leading-[18px] font-[400] cursor-pointer p-4 bg-[#FAFAFA] border-radius-[10px] mb-6">
            <h1>
              {content?.footerText}
              <span className="text-primary-red" onClick={handleTermsPress}>
                {content?.termConditions}
              </span>{' '}
            </h1>
          </div>
        </div>
      }
      buttonText={content?.btnConfirmationPopupCancel || 'Cancel'}
      extraButtonText={content?.btnUnlinkAccount || 'Unlink Account'}
      // buttonText= {content?.btnUnlinkAccount || 'Unlink Account'}
      // extraButtonText={content?.btnConfirmationPopupCancel || 'Cancel'}
      onCloseIconClick={handleCancel}
      closeIcon={true}
    />
  );
};

export default UnlinkRogersBenefits;
